// The path prefix the app is served under: "/arya" or "" (the domain root).
//
// The same deployment is reachable both ways: https://stage.ai.piramalfinance.com/arya/chat
// mounts it under the build-time prefix (package.json "homepage", exposed by CRA
// as PUBLIC_URL), while https://arya.piramalfinance.com/chat mounts it at the root.
// So the prefix is read from the live URL, but only the build-time prefix counts
// as one. Taking whatever the first segment happens to be would turn a route into
// a base on reload - /chat would fetch /chat/config.json and get index.html back.
const BUILD_BASE = new URL(process.env.PUBLIC_URL || "/", window.location.origin).pathname.replace(/\/$/, "");

const { pathname } = window.location;

export const BASE_PATH =
	BUILD_BASE && (pathname === BUILD_BASE || pathname.startsWith(`${BUILD_BASE}/`)) ? BUILD_BASE : "";

// Resolve a file that lives in public/ to a URL valid under the current base path.
// Pass a root-relative path, e.g. publicAsset("/assets/svgs/Undo.svg").
export const publicAsset = (path) => `${BASE_PATH}${path}`;
